<script>
import VueCountdown from '@chenfengyuan/vue-countdown'
import moment from 'moment'
import SvgTimerCircle from '@src/components/svg-countdown-timer-circle.vue'
export default {
  components: {
    VueCountdown,
    SvgTimerCircle,
  },
  props: {
    height: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      uuid: crypto.randomUUID(),
      timerStarted: false,
      circlesLoaded: false,
      daysProgress: 0,
      minutesProgress: 0,
      hoursProgress: 0,
      currentUTC: moment.utc().format('x'),
      targetUTC: 1775739600000,
    }
  },
  computed: {
    countdownTime() {
      return this.targetUTC - this.currentUTC > 0 ? this.targetUTC - this.currentUTC : 0
    },
  },

  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
  },

  mounted() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },

  methods: {
    openEvent() {
      window.open('http://mottomile.com/', '_blank')
    },
    measureToHeightRatio(desiredPixel) {
      const baseHeight = 300
      const ratio = baseHeight / desiredPixel
      return this.height / ratio
    },
    handleVisibilityChange() {
      if (document.visibilityState === 'visible' && this.$refs.mileCountdown?.totalMilliseconds) {
        this.updateCountdown(this.$refs.mileCountdown)
      }
    },
    updateCountdown({ days, hours, minutes, seconds }) {
      if (minutes) {
        this.minutesProgress = Math.ceil((100 * minutes) / 60)
      }
      if (hours) {
        this.hoursProgress = Math.ceil((100 * hours) / 24)
      }
      if (days) {
        this.daysProgress = Math.ceil((100 * days) / 109)
      }
    },
  },
}
</script>

<template>
  <div v-if="countdownTime" :class="$style.mileContainer" @click="openEvent">
    <div class="w-100 h-100">
      <VueCountdown
        ref="mileCountdown"
        emit-events
        :time="countdownTime"
        @progress="updateCountdown"
        @start="
          () => {
            timerStarted = true
          }
        ">
        <template v-slot="props">
          <div
            v-if="timerStarted"
            :style="{ 'margin-top': measureToHeightRatio(32) + 'px', 'margin-left': -measureToHeightRatio(-1) + 'px' }"
            :class="$style.circlesContainer">
            <div
              :style="{ width: measureToHeightRatio(200) + 'px', height: measureToHeightRatio(200) + 'px' }"
              class="position-relative">
              <SvgTimerCircle
                :base-height="height"
                :desired-height="200"
                :color="'#147fc3'"
                :progress="daysProgress || Math.ceil((100 * props.days) / 109)" />
              <p
                :class="$style.circleText"
                :style="{
                  height: measureToHeightRatio(200) + 'px',
                  'font-size': height / 4.4 + 'px',
                  color: '#147fc3',
                }"
                >{{ props.days }}</p
              >
              <p
                :class="$style.circleLabel"
                :style="{
                  'margin-top': -(height / 66.666) + 'px',
                  'font-size': height / 9.111 + 'px',
                  color: '#147fc3',
                }"
                >DAYS</p
              >
            </div>

            <div
              :style="{
                width: measureToHeightRatio(200) + 'px',
                height: measureToHeightRatio(200) + 'px',
                'margin-right': -measureToHeightRatio(20) + 'px',
                'margin-left': -measureToHeightRatio(20) + 'px',
              }"
              class="position-relative">
              <SvgTimerCircle
                :base-height="height"
                :desired-height="200"
                :color="'#ff923f'"
                :progress="hoursProgress || Math.ceil((100 * props.hours) / 24)" />
              <p
                :class="$style.circleText"
                :style="{
                  height: measureToHeightRatio(200) + 'px',
                  'font-size': height / 4.4 + 'px',
                  color: '#ff923f',
                }"
                >{{ props.hours }}</p
              >
              <p
                :class="$style.circleLabel"
                :style="{
                  'margin-top': -(height / 66.666) + 'px',
                  'font-size': height / 9.111 + 'px',
                  color: '#ff923f',
                }"
                >HOURS</p
              >
            </div>
            <div
              :style="{ width: measureToHeightRatio(200) + 'px', height: measureToHeightRatio(200) + 'px' }"
              class="position-relative">
              <SvgTimerCircle
                :base-height="height"
                :desired-height="200"
                :color="'#64c987'"
                :progress="minutesProgress || Math.ceil((100 * props.minutes) / 60)" />
              <p
                :class="$style.circleText"
                :style="{
                  height: measureToHeightRatio(200) + 'px',
                  'font-size': height / 4.4 + 'px',
                  color: '#64c987',
                }"
                >{{ props.minutes }}</p
              ><p
                :class="$style.circleLabel"
                :style="{
                  'margin-top': -(height / 66.666) + 'px',
                  'font-size': height / 9.111 + 'px',
                  color: '#64c987',
                }"
                >MINUTES</p
              >
            </div>
          </div>
        </template>
      </VueCountdown>

      <img :class="$style.mile2026" src="@assets/images/milecountdown2026/mile2026.png" alt="" />
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.mileContainer {
  @media (max-width: $sm-breakpoint + 80px) {
    margin-right: 10px;
  }

  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  cursor: pointer;
  background: white;
}

.mile2026 {
  @media (max-width: $sm-breakpoint + 80px) {
    width: 48% !important;
    margin-right: 5px;
  }

  @media (min-width: $sm-breakpoint + 81px) and (max-width: $lg-breakpoint) {
    width: 40%;
    margin-top: 7px;
  }

  position: absolute;
  top: 50%;
  right: 3%;
  z-index: 100;
  width: 48%;
  transform: translateY(-50%);
}

.circles {
  position: absolute;
  top: 50%;
  right: -19%;
  width: 66%;
  transform: translateY(-50%);
}

.circlesContainer {
  @media (max-width: $sm-breakpoint + 80px) {
    margin-left: 0 !important;
  }

  @media (min-width: $sm-breakpoint + 81px) and (max-width: $lg-breakpoint) {
    margin-left: 20px !important;
  }

  position: relative;
  z-index: 20;
  display: flex;
  justify-content: center;
  width: 50%;
  height: 100%;
}

.circleText {
  position: absolute;
  top: 3%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-family: 'Gotham', serif;
}

.circleLabel {
  position: absolute;
  bottom: -15%;
  left: 50%;
  font-family: 'Gotham', serif;
  color: white;
  text-align: center;
  transform: translateX(-50%);
}

.circleCanvasContainer {
  display: flex;

  canvas {
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
